import type { Data } from '@/api/api.ts'
import type {
  AutoReplenishment,
  AutoReplenishmentRequest,
  PaymentsCard,
  PaymentsEditCardRequestData,
} from '@/types/payments.types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}payments/`

export const getFirmCards = async (firmId: number): Promise<Data<PaymentsCard[]>> =>
  axios.get(`${urlPrefix}cards/${firmId}/`)

export const editCardName = async (
  data: PaymentsEditCardRequestData,
  cardId: PaymentsCard['id'],
): Promise<Data<PaymentsCard>> =>
  axios.post(`${urlPrefix}card/${cardId}/`, data, {
    headers: {
      'X-CSRFToken': CSRF_TOKEN,
      'Content-Type': 'multipart/form-data',
    },
  })

export const deleteCard = async (cardId: PaymentsCard['id']): Promise<Data<unknown>> =>
  axios.delete(`${urlPrefix}card/${cardId}/`, {
    headers: {
      'X-CSRFToken': CSRF_TOKEN,
    },
  })

export const getAutoReplenishments = async (): Promise<Data<AutoReplenishment[]>> =>
  axios.get(`${urlPrefix}auto-replenishments/`)

export const addAutoReplenishment = async (data: AutoReplenishmentRequest): Promise<Data<AutoReplenishment>> =>
  axios.post(`${urlPrefix}auto-replenishments/`, data, {
    headers: {
      'X-CSRFToken': CSRF_TOKEN,
      'Content-Type': 'multipart/form-data',
    },
  })

export const changeAutoReplenishment = async (
  id: AutoReplenishment['id'],
  data: AutoReplenishmentRequest,
): Promise<Data<AutoReplenishment>> =>
  axios.post(`${urlPrefix}auto-replenishments/${id}/`, data, {
    headers: {
      'X-CSRFToken': CSRF_TOKEN,
      'Content-Type': 'multipart/form-data',
    },
  })

export const deleteAutoReplenishment = async (id: AutoReplenishment['id']): Promise<Data<unknown>> =>
  axios.delete(`${urlPrefix}auto-replenishments/${id}/`, {
    headers: {
      'X-CSRFToken': CSRF_TOKEN,
    },
  })
